{
  "local": "http://localhost:5209",
  "Emulator": "",
  "Test": "https://yourlandlordapitest2.azurewebsites.net",
  "Deploy": "https://landlordapi2-cwahhydscearfsbv.swedencentral-01.azurewebsites.net",
  "Release": "https://app-api2.landlord.dinhyresvard.se"
}
